import { defineQuery } from 'bitecs';
import { Position, Movement, Input } from '../world.js';
import { TILE_SIZE, MAP_WIDTH, MAP_HEIGHT } from '../config.js';
import { tileManager, TILE_TYPES } from './tileManager.js';

const playerQuery = defineQuery([Position, Movement, Input]);

export function movementSystem(world) {
    const players = playerQuery(world);
    
    for (const player of players) {
        // Get current values
        const currentX = Position.x[player];
        const currentY = Position.y[player];
        const baseSpeed = Movement.maxSpeed[player]; // Use maxSpeed instead of current speed
        
        // Calculate movement
        let newX = currentX;
        let newY = currentY;
        
        // Check if player is in water
        const currentTile = tileManager.getTileAtPosition(currentX, currentY);
        const isInWater = currentTile && currentTile.type === TILE_TYPES.WATER;
        Movement.isSwimming[player] = isInWater ? 1 : 0;
        
        // Adjust speed based on whether player is swimming
        const speed = isInWater ? baseSpeed * 0.7 : baseSpeed; // Swimming is 30% slower
        
        // Apply movement based on input
        if (Input.up[player]) newY -= speed;
        if (Input.down[player]) newY += speed;
        if (Input.left[player]) newX -= speed;
        if (Input.right[player]) newX += speed;
        
        // Clamp position to map boundaries
        const minX = 0;
        const maxX = (MAP_WIDTH - 1) * TILE_SIZE;
        const minY = 0;
        const maxY = (MAP_HEIGHT - 1) * TILE_SIZE;
        
        newX = Math.max(minX, Math.min(maxX, newX));
        newY = Math.max(minY, Math.min(maxY, newY));
        
        // Check the tile at the new position
        const newTile = tileManager.getTileAtPosition(newX, newY);
        
        // Allow movement in both water and land
        Position.x[player] = newX;
        Position.y[player] = newY;
        Movement.isWalking[player] = !isInWater ? 1 : 0;
        
        // Update sprite position
        if (world.sprites[player]) {
            world.sprites[player].x = newX;
            world.sprites[player].y = newY;
        }
        
        // Debug logging
        // console.log('Player position:', Position.x[player], Position.y[player], 'Swimming:', isInWater);
    }
    
    return world;
} 